import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Divider } from '@mui/material';
import { Box, Grid, Typography } from '@mui/material';
import {
    ColorModeContext,
    DARK,
    isDarkMode,
    LIGHT,
} from 'app/utils/ColorContext';
import { AppButton } from 'app/components/shared/AppButton';

export const Preferences = () => {
    const theme = useTheme();
    const colorContext = React.useContext(ColorModeContext);

    const handleThemeChange = () => {
        const mode = isDarkMode(theme) ? LIGHT : DARK;
        localStorage.setItem('mode', mode);
        window.location.reload();
        colorContext.toggleColorMode();
    };

    const isChecked = () => {
        return isDarkMode(theme);
    };

    return (
        <Grid container direction="column" sx={{ p: 3 }}>
            <Typography variant="h5" component="div" gutterBottom>
                Preferences
            </Typography>
            <Divider />
            <Typography variant="subtitle1" gutterBottom component="div">
                UI Theme
            </Typography>
            <Box sx={styles.container}>
                <AppButton
                    variant="contained"
                    style={{
                        marginRight: '10px',
                    }}
                    disabled={isChecked()}
                    action={handleThemeChange}
                >
                    Dark
                </AppButton>
                <AppButton
                    variant="contained"
                    disabled={!isChecked()}
                    action={handleThemeChange}
                >
                    Light
                </AppButton>
            </Box>
        </Grid>
    );
};

const styles = {
    container: {
        display: 'flex',
        direction: 'row',
    },
};
